"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUPON_TYPE = void 0;
var COUPON_TYPE;
(function (COUPON_TYPE) {
    COUPON_TYPE["REGULAR"] = "REGULAR";
    COUPON_TYPE["EXCLUSIVE"] = "EXCLUSIVE";
    COUPON_TYPE["PARTNER_COUPON_CASHLESS"] = "PARTNER_COUPON_CASHLESS";
    COUPON_TYPE["PARTNER_COUPON_CASH"] = "PARTNER_COUPON_CASH";
})(COUPON_TYPE = exports.COUPON_TYPE || (exports.COUPON_TYPE = {}));
//# sourceMappingURL=coupon.js.map